import * as ActionTypes from './../constants';
import axios from 'axios';  
import { baseUrl } from './../index';

export default function(state={}, action) {
    switch(action.type) {
        case ActionTypes.REQUEST_OTP_VERIFY : 
            return {
                ...state,
                loading: true,
                mobile: action.mobile,
                otp: action.otp,
                err:false,
                errInfo: null
            }
        case ActionTypes.RECEIVED_OTP_VERIFY :
            return {
                ...state,
                loading: false,
                response: action.res,
                err: false,
                errInfo: null
            }
        case ActionTypes.ERROR_OTP: 
            return {
                ...state,
                err: true,
                errInfo: action.err,
                loading: false,
            }
        case ActionTypes.CLEAR_OTP_INFO:
            return { }    
        default: return state
    }

}




const dispatchRequestOtpVerify = (mobile, otp) => ({
    type: ActionTypes.REQUEST_OTP_VERIFY,
    otp,
    mobile
})

const dispatchReceivedOtpVerify = res => ({
    type: ActionTypes.RECEIVED_OTP_VERIFY,
    res
})

const dispatchErrorOtp = err => ({
    type: ActionTypes.ERROR_OTP,
    err
})

export const dispatchClearOtp = () => ({
    type: ActionTypes.CLEAR_OTP_INFO
})



export function verifyOtp(mobile, otp, isRegistrationVerify) {
    console.log(otp, 'actions otp');

    return (dispatch, getState) => {
        dispatch(dispatchRequestOtpVerify(mobile, otp));
        let data = {
            phone: mobile,
            user_otp: otp
        }

        const store = getState();
        const { registation } = store || {};
        const { response } = registation || {};
        const { first_name, last_name, phone, email, username } = response || {};

        let endPoint = 'verifyotp';
        
        if(isRegistrationVerify) {
            endPoint = 'register_verify';
            data = {
                first_name, last_name, phone, email, verify_reg_otp: otp, username 
            }
        }
        

        axios.post(`${baseUrl}/api/${endPoint}`, data)
            .then(res => {
                console.log(res, 'action verify otp res');              
                dispatch(dispatchReceivedOtpVerify(res));
                // dispatch(getSubscriptionStatus());
                // getToken(res);                               
            })
            .catch(e => {
                console.log(e, 'actions verify otp err');
                dispatch(dispatchErrorOtp(e.response));
                
            })
    }
}
